

if (!customElements.get('time-line')) {
  customElements.define('time-line', class TimeLine extends HTMLElement {
    constructor() {
      super();
      this.dragging = { status: false, start: { x: 0, y: 0 }, end: { x: 0, y: 0 } };
      this.animateItems = { drag: false };

      this.initTimeLine();
      this.initSliderDrag();
      this.initCalculateProgress();
      this.initCalculateRealOffset();

      this.easingFunctions = {
        // no easing, no acceleration
        linear: t => t,
        // accelerating from zero velocity
        easeInQuad: t => t * t,
        // decelerating to zero velocity
        easeOutQuad: t => t * (2 - t),
        // acceleration until halfway, then deceleration
        easeInOutQuad: t => t < .5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
        // accelerating from zero velocity 
        easeInCubic: t => t * t * t,
        // decelerating to zero velocity 
        easeOutCubic: t => (--t) * t * t + 1,
        // acceleration until halfway, then deceleration 
        easeInOutCubic: t => t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
        // accelerating from zero velocity 
        easeInQuart: t => t * t * t * t,
        // decelerating to zero velocity 
        easeOutQuart: t => 1 - (--t) * t * t * t,
        // acceleration until halfway, then deceleration
        easeInOutQuart: t => t < .5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t,
        // accelerating from zero velocity
        easeInQuint: t => t * t * t * t * t,
        // decelerating to zero velocity
        easeOutQuint: t => 1 + (--t) * t * t * t * t,
        // acceleration until halfway, then deceleration 
        easeInOutQuint: t => t < .5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t
      };
    }


    initCalculateRealOffset() {
      const calculateOffsets = () => {

        const last = this.querySelector('.time-line__item:last-child');
        let style = last.currentStyle || window.getComputedStyle(last);
        const itemWidth = parseInt(last.offsetWidth, 10) + parseInt(style.marginRight);
        let leftOffset = 0;

        this.querySelectorAll(':scope .time-line__item').forEach((item) => {
          item.setAttribute('data-left-offset', leftOffset);
          leftOffset += itemWidth;
        });

      };
      let resizeTimer = false;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(calculateOffsets, 250);

      });
      calculateOffsets();

    }

    initCalculateProgress() {
      const calculateProgress = () => {

        if (this.getAttribute('data-initCalculateProgress') !== 'true') {
          this.setAttribute('data-initCalculateProgress', 'true');
          setInterval(() => {
            const windowWidth = window.innerWidth;
            const maxLeftMargin = this.calculateMaxMarginLeft();
            const marginLeft = Math.abs(parseInt(this.querySelector('.time-line__flexer').style.marginLeft, 10)) || 0;

            const progressPct = Math.min((100 * marginLeft) / maxLeftMargin, 100);
            this.querySelector('.time-line__progress__pct').style.width = `${progressPct}%`;
          }, 100);
        }

      };
      calculateProgress();
    }

    wasDragging() {
      const distance = Math.sqrt(
        Math.pow(this.dragging.end.y - this.dragging.start.y, 2) +
        Math.pow(this.dragging.end.x - this.dragging.start.x, 2)
      );
      return this.dragging.status && distance > 10;
    }

    initSliderDrag() {
      if (app.main.isMobile() || app.main.isTablet()) {

        this.querySelector('.js-time-line-drag').addEventListener('touchstart', (e) => {
          const pointer = this.pointerEventToXY(e);
          this.dragging.start = { x: pointer.x, y: pointer.y };
          this.dragging.status = false;

          const onTouchMove = (emove) => {
            const pointerMove = this.pointerEventToXY(emove);
            this.dragging.status = true;
            this.dragging.end = { x: pointerMove.x, y: pointerMove.y };
          };

          const onTouchEnd = () => {
            if (this.wasDragging()) {
              const deltaX = this.dragging.end.x - this.dragging.start.x;
              if (Math.abs(deltaX) > 50) { // Threshold for swipe detection
                if (deltaX < 0) {
                  const next = this.querySelector('.time-line__item.active').nextElementSibling;
                  if (next) this.openCase(next);
                } else {
                  const prev = this.querySelector('.time-line__item.active').previousElementSibling;
                  if (prev) this.openCase(prev);
                }
              }
            }

            document.removeEventListener('touchmove', onTouchMove);
            document.removeEventListener('touchend', onTouchEnd);
          };

          document.addEventListener('touchmove', onTouchMove);
          document.addEventListener('touchend', onTouchEnd);
        });
      }
      else {
        this.querySelector('.js-time-line-drag').addEventListener('mousedown', (e) => {
          const drag = this.querySelector('.time-line__flexer');
          const pointer = this.pointerEventToXY(e);
          let prevTime = new Date();
          let prevPosX = pointer.x;
          const maxLeftMargin = this.calculateMaxMarginLeft();
          let marginLeftStart = parseInt(drag.style.marginLeft, 10) || 0;

          drag.dataset.speed = 0;
          this.dragging.status = false;
          this.dragging.start = { x: pointer.x, y: pointer.y };

          const onMouseMove = (emove) => {

            const pointerMove = this.pointerEventToXY(emove);
            this.dragging.status = true;
            this.dragging.end = { x: pointerMove.x, y: pointerMove.y };

            const now = new Date();
            const currentPosX = pointerMove.x;
            const distance = prevPosX - currentPosX;
            const timeInterval = now - prevTime;

            const speed = timeInterval ? distance / timeInterval : 0;
            drag.dataset.speed = speed;

            const speedMultiplier = Math.min(1 + Math.abs(speed), 4);
            let marginLeft = marginLeftStart - distance * speedMultiplier;
            if (marginLeft < -maxLeftMargin - 100) {
              marginLeft = -maxLeftMargin - 100;
            }
            if (marginLeft > 100) {
              marginLeft = 100;
            }

            prevTime = now;
            prevPosX = currentPosX;
            marginLeftStart = marginLeft;


            this.animateScroll(drag, marginLeft);
          };

          const onMouseUp = () => {
            let bounceback = false;

            if (marginLeftStart < -maxLeftMargin) {
              marginLeftStart = -maxLeftMargin;
              bounceback = true;
            }
            if (marginLeftStart > 0) {
              marginLeftStart = 0;
              bounceback = true;
            }

            if (bounceback) {
              this.animateScroll(drag, marginLeftStart);
            }

            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);


          };

          document.addEventListener('mousemove', onMouseMove);
          document.addEventListener('mouseup', onMouseUp);

        });
      }

    }

    scrollToActiveCase() {
      const active = this.querySelector('.time-line__item.active');
      const drag = this.querySelector('.time-line__flexer');

      if (active) {
        const left = parseInt(active.getAttribute('data-left-offset'), 10);
        const maxLeftMargin = this.calculateMaxMarginLeft();
        let marginLeft = -left;

        if (marginLeft < -maxLeftMargin) marginLeft = -maxLeftMargin;
        if (marginLeft > 0) marginLeft = 0;

        this.animateScroll(drag, marginLeft);


      }
    }

    calculateMaxMarginLeft() {
      const windowWidth = window.innerWidth;
      let flexerWidth = 0;

      this.querySelectorAll(':scope .time-line__item').forEach((item) => {
        let style = item.currentStyle || window.getComputedStyle(item);
        flexerWidth += item.offsetWidth;

        flexerWidth += parseInt(style.marginRight);
      });

      flexerWidth += parseInt(getComputedStyle(this.querySelector('.time-line__container')).marginLeft, 10);
      return flexerWidth - windowWidth;
    }

    initTimeLine() {
      //set total
      let pageTotalContainer = this.querySelector('.time-line__pagination__pages__total');
      if (pageTotalContainer) {
        let total = parseInt(this.querySelectorAll(':scope .time-line__item').length);
        pageTotalContainer.innerHTML = total.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
      }

      this.openCase(document.querySelector('.time-line__item:first-child'));

      this.querySelectorAll(':scope .js-time-line-open').forEach((item) => {
        item.addEventListener('click', (e) => {
          if (!this.wasDragging()) {
            this.openCase(e.target.closest('.time-line__item'));
          }
        });
      });

      this.querySelector('.js-time-line-next').addEventListener('click', (e) => {
        const next = this.querySelector('.time-line__item.active').nextElementSibling;
        if (next) this.openCase(next);
      });

      this.querySelector('.js-time-line-previous').addEventListener('click', (e) => {
        const prev = this.querySelector('.time-line__item.active').previousElementSibling;
        if (prev) this.openCase(prev);
      });

    }


    openCase(item) {
      this.closeAllCases();

      item.classList.add('active');
      item.querySelector('.time-line__item__cover').setAttribute('aria-expanded', 'true');
      item.querySelector('.time-line__item__text').setAttribute('aria-hidden', 'false');

      //set current page
      let pageCurrentContainer = this.querySelector('.time-line__pagination__pages__current');
      if (pageCurrentContainer) {
        let current = parseInt($(item).index()) + 1;
        pageCurrentContainer.innerHTML = current.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
      }

      this.scrollToActiveCase();

      const paginationPrev = this.querySelector('.time-line__pagination__previous');
      const paginationNext = this.querySelector('.time-line__pagination__next');

      if (item.previousElementSibling) {
        paginationPrev.setAttribute('aria-disabled', 'false');
      } else {
        paginationPrev.setAttribute('aria-disabled', 'true');
      }

      if (item.nextElementSibling) {
        paginationNext.setAttribute('aria-disabled', 'false');
      } else {
        paginationNext.setAttribute('aria-disabled', 'true');
      }
    }

    closeAllCases() {
      this.querySelectorAll(':scope .time-line__item').forEach((item) => {
        item.classList.remove('active');
        item.querySelector('.time-line__item__cover').setAttribute('aria-expanded', 'false');
        item.querySelector('.time-line__item__text').setAttribute('aria-hidden', 'true');

      });
    }

    pointerEventToXY(e) {
      const touch = e.touches ? e.touches[0] : e;
      return { x: touch.clientX, y: touch.clientY };
    }

    animateScroll(drag, marginLeft) {
      const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
      let parent = this;
      let easing = 'easeOutQuad';
      let time = 1000;
      let startingScrollPosition = parseInt(drag.style.marginLeft, 10) || 0;
      let rangeInPixels = parseInt(marginLeft) - startingScrollPosition;

      if (parent.animateItems.drag) {
        cancelAnimationFrame(parent.animateItems.drag);
        setTimeout(() => {
          drag.style.marginLeft = marginLeft + 'px';
        }, 50);


      }

      let sequenceObj = {};

      sequenceObj.progress = (function (percentage) {
        drag.style.marginLeft = (startingScrollPosition + (parent.easingFunctions[easing](percentage) * rangeInPixels)) + 'px';
      });
      sequenceObj.done = function () {
        parent.animateItems.drag = false;
      };

      this.animate(sequenceObj, time, (animationId) => {
        parent.animateItems.drag = animationId;
      });



    }


    /**
    * @param callbackObj Object An object with callbacks in .start, .progress, and .done
    * @param duration Integer Total duration in milliseconds
    */
    animate(callbackObj, duration, callbackAnimateId) {
      let requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame;
      let startTime = 0, percentage = 0, animationTime = 0;
      let animationId = false;



      duration = duration || 1000;

      const animation = function (timestamp) {
        if (startTime === 0) {
          startTime = timestamp;
        } else {
          animationTime = timestamp - startTime;
        }
        if (typeof callbackObj.start === 'function' && startTime === timestamp) {
          callbackObj.start();
          animationId = requestAnimationFrame(animation);
          if (typeof callbackAnimateId === 'function') {
            callbackAnimateId.call(null, animationId);
          }
        } else if (animationTime < duration) {
          if (typeof callbackObj.progress === 'function') {
            percentage = animationTime / duration;
            callbackObj.progress(percentage);
          }
          animationId = requestAnimationFrame(animation);
          if (typeof callbackAnimateId === 'function') {
            callbackAnimateId.call(null, animationId);
          }
        } else if (typeof callbackObj.done === 'function') {
          callbackObj.done();
        }
      };
      animationId = requestAnimationFrame(animation);
      if (typeof callbackAnimateId === 'function') {
        callbackAnimateId.call(null, animationId);
      }
      return animationId;
    }
  });




}

